import * as m from "mithril";
import { NavBar } from '../../components/NavBar';
import AppContext from '../../context/AppContext';
import './AppPaymentPage.scss';
import buildLanguageChangeActions from "../common/LanguageNavActions";
import { ActionItemDescriptor } from "../../components/MaterialDesignComponents";
import ModalDialog from "../../components/ModalDialog";
import { TentativeBookingDTO } from "../../apiclient/ApiDtos";



interface Attrs {
    appContext: AppContext,
    collapsedActionItems: ActionItemDescriptor[],
    tentativeBooking: TentativeBookingDTO,
    isBacktracking : boolean,
    onClose: () => void,
    onBacktrack:() => void,
    onBacktrackCancelled: () => void,
    onBacktrackConfirmed: () => void,
    onForceBackToHome: () => void
}


function PaymentExistingErrorPage(): m.Component<Attrs> {
    let backToHome : () => void;
    const handlePageShow = (event: Event) => {
        if ((event as PageTransitionEvent).persisted) { 
            console.debug("Backing from payment page.")
            backToHome();
            //alert("back to home")
        }
    };
    return {
        oncreate: () => {
            window.addEventListener('pageshow', handlePageShow);
            const navigationEntries = performance.getEntriesByType("navigation");
            if (navigationEntries.length > 0) {
                const navigationEntry = navigationEntries[0] as PerformanceNavigationTiming;
                if (navigationEntry.type === "back_forward") {
                    //showLoading = false;
                    //m.redraw();
                }
            }
        },
        onremove: () => {
            window.removeEventListener('pageshow', handlePageShow);
        },
        view(vnode) {
            backToHome = vnode.attrs.onForceBackToHome;
            let messageProvider = vnode.attrs.appContext.getMessageProvider();
            let langChangeActionItems = buildLanguageChangeActions(vnode.attrs.appContext);

            return [
                m("div.app-layout",
                    [
                        m(NavBar, {
                            title: messageProvider.get("nav_title.already_paid"),
                            collapsedActionItems: vnode.attrs.collapsedActionItems,
                            canClose: true,
                            actionItems: langChangeActionItems,
                            onClose: () => {
                                vnode.attrs.onClose();
                            },
                            onBackPressed: () => {
                                vnode.attrs.onBacktrack();
                            }
                        }),

                        m("div.app-area-main", [
                            m("div.card.mt-3.mx-1",
                                m("div.card-body.py-4.text-center",
                                    m("h5", messageProvider.get("message_title.payment_completed")),
                                    m("p.mt-3.mb-2",
                                        m("span.opacity-75", 
                                            messageProvider.get("message_description.payment_completed")
                                        )
                                    ),
                                    m("div.mt-3", [
                                        m("p", messageProvider.get("message.help_info")),
                                        m("p.font-weight-bold", [
                                            "Support Hotline ",
                                            m("a", { 
                                                href: "tel:09 777 111 811",
                                                style: {
                                                    textDecorationLine: "underline",
                                                    textDecorationStyle: "dotted"
                                                },
                                            }, "09 777 111 811")
                                        ])
                                    ])
                                ),
                                m("div.card-footer.text-center",
                                    m("h5.text-primary.mt-1._card", 
                                        "Booking Session ID: ", 
                                        m("b", vnode.attrs.tentativeBooking.id)
                                    )
                                )
                            )

                        ]),


                        vnode.attrs.appContext.isLeavingExtraMarginBottom() ?
                            m("div.app-area-system-nav") : null,

                        m(ModalDialog, {
                            title: messageProvider.get("restart_warning_title"),
                            message: messageProvider.get("restart_warning_message"),
                            shouldOpen: vnode.attrs.isBacktracking,
                            iconType: 'exclamation_circle',
                            iconThemeClass: " svg-medium svg-warning",
                            onClosed: () => {
                                vnode.attrs.onBacktrackCancelled()
                            },
            
                                actionItems: [
                                    {
                                        label: "OK",
                                        onclick: () => {
                                            vnode.attrs.onBacktrackConfirmed()
                                        }
                                    },
                                    {
                                        label: "Cancel",
                                        onclick: () => {
                                            vnode.attrs.onBacktrackCancelled();
                                        }
                                    }
            
                                ]
                            })
                    ])
            ]
        }

    }
}

export default PaymentExistingErrorPage;